/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Login_Required_HintInputs */



/**
* | output |
* | --- |
* | "Visitors must sign in by email before they can open this canvas or use its data. Leave this off to let the canvas offer sign-in on its own — add a sign-in bu..." |
*
* @param {Artifact_Visitor_Login_Required_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_login_required_hint = /** @type {((inputs?: Artifact_Visitor_Login_Required_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Login_Required_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besucher müssen sich per E-Mail anmelden, bevor sie dieses Canvas öffnen oder seine Daten nutzen können. Lassen Sie die Option aus, damit das Canvas die Anmeldung selbst anbietet — fügen Sie ihm einen Anmelde-Button hinzu, dann können sich Besucher freiwillig zu erkennen geben.")
	return /** @type {LocalizedString} */ ("Visitors must sign in by email before they can open this canvas or use its data. Leave this off to let the canvas offer sign-in on its own — add a sign-in button to it and visitors can identify themselves without being forced to.")
});